module.exports = "/img/_/_/_/assets/images/creeper/battle/common//16.jpg?ebaf49ab73a04a352bc0f762573042df";